var form = (function () {
    "use strict";

    var main = $('#main'),
		form = $('.xform');

    // Only add listener on pages with a form
    if (form.length > 0) {

        // Trigger placeholder plugin for IE
        form.find('input, textarea').placeholder();
    }

    //  Trigger chosen
    $('select').chosen({ disable_search: true });

})();